import { Button, Modal, Result, Space } from '@bfe/moly';
import { message } from 'antd';
import { useState } from 'react';

import { useI18nContext } from '@/i18n/I18n';
import { switchLogin } from '@/services/subAccount';
import storage from '@/utils/storage';

const TipGaBindModal = ({
  memberInfo,
  showGaVerifyTipModal,
  onClose,
}: {
  memberInfo: {
    memberId: string;
    loginName: string;
  };
  showGaVerifyTipModal: boolean;
  onClose: () => void;
}) => {
  const [$t] = useI18nContext();
  const [switching, setSwitching] = useState(false);

  const handleClose = () => {
    onClose();
  };

  const handleBind = () => {
    setSwitching(true);
    switchLogin({ target_member_id: `${memberInfo.memberId}` })
      .then(() => {
        storage.session.set('newSubAccountGaBind', '1');
        localStorage.setItem(
          'uniframe.switchAccountSuccess',
          memberInfo.loginName,
        ); // 设置localStorage，用于广播其他窗口的刷新弹窗提示
        window.location.href = '/app/user/security#openGaBind';
      })
      .catch((error: { ret_code: number; ret_msg: string }) => {
        message.error(error.ret_msg);
      })
      .finally(() => {
        setSwitching(false);
      });
  };

  return (
    <Modal
      title={false}
      open={showGaVerifyTipModal}
      width={480}
      onCancel={handleClose}
      okText={false}
      cancelText={false}
      closable={false}
    >
      <Result
        title={false}
        subTitle={$t('newSubAccountGaVerifyTipModal')}
        status="warning"
        extra={
          <Space size={24}>
            <Button
              size="middle"
              variant="secondary"
              onClick={handleClose}
              disabled={switching}
            >
              {$t('back')}
            </Button>
            <Button
              size="middle"
              variant="primary"
              onClick={handleBind}
              loading={switching}
            >
              {$t('bindNow')}
            </Button>
          </Space>
        }
      ></Result>
    </Modal>
  );
};

export default TipGaBindModal;
